import React from 'react';

const CommonDropdown = ({ itemLists, selectedItem, onSetSelectedItem, title }) => {
	return (
		<div>
			<select
				name="category"
				id="category"
				value={selectedItem}
				onChange={(e) => onSetSelectedItem(e.target.value)}
			>
				<option value={''}>{title}</option>
				{itemLists?.map((item) => (
					<option value={item.id} key={item.id}>
						{item.name}
					</option>
				))}
			</select>
		</div>
	);
};

export default CommonDropdown;
